<template>
  <div class="home-container">
    <div class="content">
      <h1 class="main-title">Aertix</h1>
      <div class="tagline">
        <span class="line"></span>
        <p>{{ subtitle }}</p>
      </div>
      <div class="description">
        <p>Edge • Of • Everything</p>
      </div>
    </div>
    <div class="background-text">
      <span>est. 2024</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subtitle: "Fueling innovation, chasing meaning, and thriving in chaos.",
    };
  },
  metaInfo() {
    return {
      title: 'Aertix'
    }
  }
};
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.content {
  text-align: center;
  z-index: 2;
}

.main-title {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 8rem;
  font-weight: 300;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -4px;
  line-height: 1;
  animation: fadeIn 1s ease-out;
}

.tagline {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  animation: fadeIn 1s ease-out 0.3s backwards;
}

.line {
  width: 60px;
  height: 1px;
  background-color: #1a1a1a;
}

.tagline p {
  font-family: 'Inter', sans-serif;
  font-size: 1.25rem;
  font-weight: 300;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: 0.02em;
}

.description {
  margin-top: 1.5rem;
  animation: fadeIn 1s ease-out 0.6s backwards;
}

.description p {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 300;
  color: #404040;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.background-text {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1rem;
  color: #1a1a1a;
  opacity: 0.3;
  font-weight: 300;
  letter-spacing: 0.1em;
  animation: fadeIn 1s ease-out 0.9s backwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Optional: Add hover effect on main title */
.main-title:hover {
  transform: scale(1.02);
  transition: transform 0.3s ease;
}

@media (max-width: 768px) {
  .main-title {
    font-size: 4rem;
    letter-spacing: -2px;
  }

  .tagline {
    flex-direction: column;
    gap: 1rem;
  }

  .line {
    width: 40px;
  }

  .tagline p {
    font-size: 1.1rem;
  }

  .description p {
    font-size: 0.875rem;
  }

  .background-text {
    bottom: 1rem;
    right: 1rem;
    font-size: 0.875rem;
  }
}
</style>
